import { useEffect } from 'react'

import { useActions } from '../../../../draft-trades/store/use-actions'
import { useAppSelector } from '../../../store/hooks'
import { actions as rawActions } from '../state/portfolio-slice'
import { PortfolioStepStateless } from '../templates'

export const PortfolioStep = () => {
  const state = useAppSelector(state => state.portfolio)
  const builderState = useAppSelector(state => state.builder)
  const actions = useActions(rawActions)

  useEffect(() => {
    actions.init(builderState.note)
  }, [actions, builderState.note])
  useEffect(() => {
    actions.setBuilderErrors(builderState.errors)
  }, [actions, builderState.errors])

  const onSaveAndContinue = () => {
    actions.moveNext()
  }
  const onMoveBack = () => {
    actions.moveBack()
  }

  return (
    <PortfolioStepStateless
      actions={actions}
      state={state}
      onMoveBack={onMoveBack}
      onSaveAndContinue={onSaveAndContinue}
    />
  )
}
